webpackJsonp([14663744061042],{

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/A2P StSimeon_HMatte.e4fe05e9.jpg";

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _boutonCollectif = __webpack_require__(19);
	
	var _boutonCollectif2 = _interopRequireDefault(_boutonCollectif);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/collectif-musical-violons-du-roy/', className: 'etiquette' },
	    _react2.default.createElement(_boutonCollectif2.default, null),
	    _react2.default.createElement(
	      'span',
	      null,
	      'Les violons du Roy'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _titreAxe = __webpack_require__(14);
	
	var _titreAxe2 = _interopRequireDefault(_titreAxe);
	
	var _personnage = __webpack_require__(26);
	
	var _personnage2 = _interopRequireDefault(_personnage);
	
	var _btnLePalaisMontcalm = __webpack_require__(97);
	
	var _btnLePalaisMontcalm2 = _interopRequireDefault(_btnLePalaisMontcalm);
	
	var _btnHenrietteBelley = __webpack_require__(94);
	
	var _btnHenrietteBelley2 = _interopRequireDefault(_btnHenrietteBelley);
	
	var _btnCapsuleViolons = __webpack_require__(87);
	
	var _btnCapsuleViolons2 = _interopRequireDefault(_btnCapsuleViolons);
	
	var _btnViolonsDuRoy = __webpack_require__(68);
	
	var _btnViolonsDuRoy2 = _interopRequireDefault(_btnViolonsDuRoy);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _A2PStSimeon_HMatte = __webpack_require__(854);
	
	var _A2PStSimeon_HMatte2 = _interopRequireDefault(_A2PStSimeon_HMatte);
	
	var _indexModule = __webpack_require__(16);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _imageFooterAxe = __webpack_require__(109);
	
	var _imageFooterAxe2 = _interopRequireDefault(_imageFooterAxe);
	
	var _fragAxe = __webpack_require__(104);
	
	var _fragAxe2 = _interopRequireDefault(_fragAxe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'fondations' } }),
	            _react2.default.createElement(
	                _sidebarLeft2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: "100%", height: "786px", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-end", paddingBottom: "1.45rem" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: "520px", width: "70%", height: "auto", alignSelf: "center" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'metadata--wrapper' },
	                            _react2.default.createElement('img', { src: _A2PStSimeon_HMatte2.default, alt: '' }),
	                            _react2.default.createElement(
	                                _info2.default,
	                                null,
	                                'Sym\xE9on est un personnage. Illustration de Hema, Ludovica, 2017.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(
	                    _titreAxe2.default,
	                    null,
	                    'Monuments'
	                ),
	                _react2.default.createElement(_personnage2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Sym\xE9on',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _indexModule2.default['date'] },
	                        '-66 BC - 00'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Selon l\u2019\xC9vangile de Saint-Luc, c\u2019est au temple de Nazareth qu\u2019un voyageur du nom de Sym\xE9on reconnut en J\xE9sus le Messie attendu. Personnage secondaire mais fondamental du christianisme proph\xE9tique, Sym\xE9on aurait \xE9t\xE9 averti bien \xE0 l\u2019avance par le Saint-Esprit de cette rencontre. Ses visions lui auraient r\xE9v\xE9l\xE9 qu\u2019il ne mourrait pas avant d\u2019avoir reconnu le Christ, et qu\u2019une fois la rencontre et la reconnaissance consum\xE9e, il s\u2019\xE9teindrait bienheureux. 1726 ans plus tard, l\u2019histoire de Sym\xE9on inspire la cantate BWV 82 au compositeur J.S. Bach.'
	                ),
	                _react2.default.createElement(_fragAxe2.default, null)
	            ),
	            _react2.default.createElement(
	                _sidebarRight2.default,
	                null,
	                _react2.default.createElement(_btnCapsuleViolons2.default, null),
	                _react2.default.createElement(_btnLePalaisMontcalm2.default, null),
	                _react2.default.createElement(_btnHenrietteBelley2.default, null),
	                _react2.default.createElement(_btnViolonsDuRoy2.default, null)
	            )
	        ),
	        _react2.default.createElement(_imageFooterAxe2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-symeon-js-f0e9b37dad146f35a272.js